import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { tradingSlice } from '!views/index';
import { getSelectedTrade } from '!views/Trading/redux/trading.selectors';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import { TrlAccordion } from '../TrlAccordion';
import { getEventTypeLabel } from './TrlDocsModal.helper';
import { DialogStyled, PaperStyled } from './TrlDocsModal.styles';

export const TrlDocsModal = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const selectedItem = useSelector(getSelectedTrade);

  useEffect(() => {
    if (open)
      dispatch(
        tradingSlice.actions.loadDocListRequest({
          ordBookKey: selectedItem.ordBookKey,
        }),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const displayedDocs = selectedItem?.docs
    .reduce((acc, doc) => {
      const eventType = getEventTypeLabel(doc.execType);

      acc.push({
        id: doc.voucherId,
        header: [
          {
            value: doc.timestamp,
            type: 'datetime',
          },
        ],
        content: [
          {
            label: 'TRLT_UI-REPORT_TYPE',
            value: eventType
              ? TrlFormattedMessagePlain({ id: eventType })
              : null,
          },
          {
            label: 'TRLT_UI-PROOF',
            value: doc.voucherId,
            type: 'openfilespreview',
          },
        ],
      });

      return acc;
    }, [])
    .sort((a, b) => new Date(b.header[0].value) - new Date(a.header[0].value));

  return (
    <DialogStyled open={open} onClose={onClose} PaperComponent={PaperStyled}>
      <TrlAccordion
        data={displayedDocs}
        title="TRLT_UI-PROOFS"
        isModal
        onCloseModal={onClose}
        isLoadingData={selectedItem?.isLoadingDocs}
      />
    </DialogStyled>
  );
};

TrlDocsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
